module.exports = __webpack_public_path__ + "files/8e971dda11e0c4150a15e13a0ef116d4.png";